import React from 'react';

import LookupStatusBadge from '~components/LookupStatusBadge';

import { NeedPriority } from '~clients/models';

import { NEED_PRIORITY_LABELS } from '~clients/config/carePlanEnums';

// Frontend-only enum → colour (Bootstrap 5 tokens): High = danger, Medium = warning,
// Low = secondary. Rendered through the shared LookupStatusBadge pill.
const PRIORITY_COLOUR: Record<NeedPriority, string> = {
  high: 'dc3545',
  medium: 'ffc107',
  low: '6c757d',
};

interface ComponentProps {
  priority: NeedPriority;
}

const PriorityBadge: React.FC<ComponentProps> = ({ priority }) => (
  <LookupStatusBadge
    status={{ tag: priority, name: NEED_PRIORITY_LABELS[priority], colour: PRIORITY_COLOUR[priority] }}
    dataCy={`care-plan-need-priority-${priority}`}
  />
);

export default PriorityBadge;
